module.exports = __webpack_public_path__ + "img/dr1.png";